angular.module('cvsApp').service('getStoreLocationService',['networkService', 'xdrService', 'getStoreLocationModel', 'configManager', function (NS, XS, GSLM, CM) {
   	
	function getStoreLocationService (){	
		this.getStoreLocation = function(storeDetails,callBackSuccess,component){
			//get url 
			var url = CM.getStoreLocationUrl('GET_STORE_LOCATIONS', '1.0',storeDetails,component);
			var plainUrl = CM.getPlainApiUrl(url);
			var request = {url:plainUrl,
							header:{"Content-Type":"application/json", "accept": "application/xml"},
							data:getRequestBody(url),
							onSuccess:callBackSuccess
						};
            // if(url.indexOf('hashKey') > -1){
            //     delete request.data;
            // }
			cvsUtility.commonServiceCode(plainUrl,"getStoreLocations",GSLM,request,callBackSuccess,NS);
							
		};
		

		var getRequestBody = function(entities){
			var requestJson = { serviceParams: CM.getModifiedParams(entities) };
			return requestJson;
		};			
	}
	
	return new getStoreLocationService();	
}]);
